import type { Buff } from "@/types/tile";
import { translate } from "@/utils/translate";

export const buffIcon = (buff: Buff): string => {
	if (!translate(`ui.buff_${buff.type}`).includes("{icon}")) return "";
	let buffIcon = "";
	if (buff.type.includes("attack")) buffIcon = "swords";
	if (buff.type.includes("armor")) {
		if (buff.type.includes("melee")) {
			buffIcon = "purple-shield";
		} else if (buff.type.includes("ranged")) {
			buffIcon = "orange-shield";
		} else if (buff.type.includes("siege")) {
			buffIcon = "green-shield";
		} else {
			buffIcon = "blue-shield";
		}
	}
	if (buff.type.includes("hp")) buffIcon = "hearth";
	if (buff.type.includes("supply")) buffIcon = "rations";
	return buffIcon;
};

export const buffTooltip = (buff: Buff): string => {
	if (!translate(`ui.buff_${buff.type}`).includes("{icon}")) return "";
	let tooltip = "";
	if (buff.type.includes("attack")) tooltip = "ui.attack";
	if (buff.type.includes("armor")) tooltip = "ui.armor";
	if (buff.type.includes("hp")) tooltip = "ui.health";
	if (buff.type.includes("supply")) tooltip = "ui.supply";
	return tooltip;
};
export const buffTextData = (
	buff: Buff,
): { pretext: string; posttext: string } => {
	const text = translate(`ui.buff_${buff.type}`)
		.replace("{number}", buff.value.toString())
		.replace("{range}", "1");
	const [pretext, posttext = ""] = text.split("{icon}");
	return {
		pretext,
		posttext,
	};
};
